import React, { useContext, useState } from "react";
import { 
  Avatar, 
  Typography, 
  MenuItem,
  Box,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import FaceOutlinedIcon from "@mui/icons-material/FaceOutlined";
import { useTheme } from "@mui/styles";
import { useMsal } from "@azure/msal-react";
import { FlexContainer } from "./styled/Container.styled";
import { AuthContext } from "../../contexts/AuthContext";
import { ThemeContext } from "../../contexts/ThemeContext";
import { ConfiguratorContext } from "../../contexts/ConfiguratorContext";
import AccountPopper from "./AccountPopper";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../config/msal.config";
import {
  LOGOUT_HAS_MESSAGE_KEY,
  LOGOUT_MESSAGE_KEY,
  LOGOUT_SUBTITLE_KEY,
  FOOTER_COMPANY_NAME_KEY,
  LOGO_IMAGE_KEY,
} from "../constants/Configurator.constants";
import { blobToBase64 } from "../utils/utility-functions";
import { useMediaQuery } from "@mui/material";

const NavbarAccountInfo = () => {
  const theme = useTheme();
  const { instance } = useMsal();
  const { addPendingRequest, removePendingRequest } = useContext(ThemeContext);
  const { edittedFields, addBatchOfEdittedFields } = useContext(ConfiguratorContext);
  const {
    userDetails,
    activeLoan,
    setActiveLoan,
    loans,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [popperOpen, setPopperOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [accountPopperOpen, setAccountPopperOpen] = useState(false);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);

  const userName = userDetails?.name || "User";
  const identifier = `#${activeLoan || ""}-${userName.replace(/\s+/g, "")}`;

  // const currentHours = getHours(new Date());
  
  // const determineGreeting = (hour) => {
  //   if (hour >= 5 && hour < 12) {
  //     return DEFAULT_MORNING_GREETING;
  //   }
  //   if (hour >= 12 && hour < 18) {
  //     return DEFAULT_AFTERNOON_GREETING;
  //   }
  //   if (hour >= 18 || hour < 5) {
  //     return DEFAULT_EVENING_GREETING;
  //   }
  // };

  const saveLogoutMarketingItems = async () => {
    try {
      const logoField = edittedFields.find((item) => item.key === LOGO_IMAGE_KEY);
      if (logoField?.value) {
        const base64Logo = await blobToBase64(logoField.value);
        sessionStorage.setItem("_l", base64Logo);
      }
    } catch (_) {}
    sessionStorage.setItem(
      "_hm",
      edittedFields.find((item) => item.key === LOGOUT_HAS_MESSAGE_KEY)
        ?.value === "true",
    );
    sessionStorage.setItem(
      "_m",
      edittedFields.find((item) => item.key === LOGOUT_MESSAGE_KEY)?.value ||
      "",
    );
    sessionStorage.setItem(
      "_s",
      edittedFields.find((item) => item.key === LOGOUT_SUBTITLE_KEY)?.value ||
      "",
    );
    sessionStorage.setItem("_bc", theme.palette.secondary.main);
    sessionStorage.setItem(
      "_cn",
      edittedFields.find((item) => item.key === FOOTER_COMPANY_NAME_KEY)?.value ||
      "Mortgage Builder",
    );
  };

  const logout = async () => {
    setPopperOpen(false);
    setAccountPopperOpen(false);
    addPendingRequest();
    if (edittedFields.some((item) => item.modified)) {
      const confirmationResponse = await window.confirm(
        "Are you sure you want to log out before publishing your changes?",
      );
      if (confirmationResponse) {
        const modifiedElements = edittedFields.map((item) => {
          return { ...item, modified: false };
        });
        addBatchOfEdittedFields(modifiedElements);

        saveLogoutMarketingItems();

        instance.logoutRedirect(loginRequest).catch((e) => {
          console.error(e);
        });
      } else {
        removePendingRequest();
      }
    } else {
      saveLogoutMarketingItems();
      instance.logoutRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    }
  };

  const togglePopper = (e) => {
    if (popperOpen) {
      setAnchorEl(null);
      setPopperOpen(false);
    } else {
      setAnchorEl(e.currentTarget);
      setPopperOpen(true);
    }
  };

  const toggleAccountPopper = (e) => {
    if (accountPopperOpen) {
      setAccountAnchorEl(null);
      setAccountPopperOpen(false);
    } else {
      setAccountAnchorEl(e.currentTarget);
      setAccountPopperOpen(true);
    }
  };

  const handlePopperClose = (e) => {
    if (anchorEl && anchorEl.contains(e.target)) return;
    setPopperOpen(false);
  };

  const handleAccountPopperClose = (e) => {
    if (accountAnchorEl && accountAnchorEl.contains(e.target)) return;
    setAccountPopperOpen(false);
  };

  const handleLoanSelect = (loan) => {
    setActiveLoan(loan);
    setPopperOpen(false);
  };

  const accountCallback = () => {
    navigate("/profile");
    setPopperOpen(false);
    setAccountPopperOpen(false);
  };

  return (
    <>
      <FlexContainer 
        alignitems="center" 
        gap="10px" 
        justifycontent="space-between" 
        width="100%"
      >
        {isMobile ? (
          // Mobile: Show account elements in the blue avatar
          <Box sx={{ position: 'relative' }}>
            <Avatar
              sx={{ 
                width: 40, 
                height: 40, 
                backgroundColor: theme.palette.primary.main,
                cursor: 'pointer'
              }}
              onClick={toggleAccountPopper}
            >
              {userName.substring(0, 1)}
            </Avatar>
            
            {/* Mobile Account Popper */}
            <AccountPopper
              accountPopperOpen={accountPopperOpen}
              anchorElement={accountAnchorEl}
              handleAccountPopperClose={handleAccountPopperClose}
              accountCallback={accountCallback}
              logoutCallback={logout}
            />
          </Box>
        ) : (
          // Desktop: Show avatar separately
          <Avatar
            sx={{ 
              width: 40, 
              height: 40, 
              backgroundColor: theme.palette.primary.main,
              cursor: 'pointer'
            }}
            onClick={toggleAccountPopper}
          >
            {userName.substring(0, 1)}
          </Avatar>
        )}
        
        <FlexContainer 
          alignitems="center" 
          gap="10px" 
          onClick={togglePopper} 
          sx={{ cursor: "pointer" }}
        >
          <Typography fontWeight="bold" fontSize="1rem">
            {identifier}
          </Typography>
          <KeyboardArrowDownIcon
            fontSize="medium"
            color="action"
            sx={{
              aspectRatio: "1/1",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              padding: "4px",
              transform: popperOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
            }} 
          />
        </FlexContainer>
      </FlexContainer>

      {/* Desktop Account Popper */}
      {!isMobile && (
        <AccountPopper
          accountPopperOpen={accountPopperOpen}
          anchorElement={accountAnchorEl}
          handleAccountPopperClose={handleAccountPopperClose}
          accountCallback={accountCallback}
          logoutCallback={logout}
        />
      )}

      {/* Loan Selection Popper - Only loans, no account elements */}
      <AccountPopper
        accountPopperOpen={popperOpen}
        anchorElement={anchorEl}
        handleAccountPopperClose={handlePopperClose}
        accountCallback={accountCallback}
        logoutCallback={logout}
        showAccountElements={false}
      >
        {loans && loans.length > 0 && (
          <>
            <Typography 
              variant="subtitle2" 
              sx={{ 
                padding: '0 16px 8px', 
                fontWeight: 'bold', 
                color: theme.palette.text.secondary 
              }}
            >
              Select Active Loan
            </Typography>
            {loans.map((loan) => (
              <MenuItem
                key={loan}
                onClick={() => handleLoanSelect(loan)}
                selected={loan === activeLoan}
                sx={{
                  backgroundColor: loan === activeLoan 
                    ? theme.palette.primary.light 
                    : 'transparent',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover
                  }
                }}
              >
                {`Loan #${loan}`}
              </MenuItem>
            ))}
          </>
        )}
      </AccountPopper>
    </>
  );
};

export default NavbarAccountInfo; 